/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckboxSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 16v2h-6v-2zM12 6v2H4v8h8v-3h2v5H2V6zm1.761 2L15 9.161 8.258 15 5 11.774l1.239-1.161 2.02 2.064zM22 11v2h-6v-2zm0-5v2h-6V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCheckboxSet as CheckboxSet };
